import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, SelectionMode, ConstrainMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { MessageBars } from '../Outils/MessageBars';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import '../../css/immocom.css';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

/*
***************************************************************
 PROPS:
    int idJournalisation
    bool displayErrorColumn : détermine si la colonne erreur doit être affichée
***************************************************************
*/

export class DetailsListLog extends React.Component {
    _creationContent() {
        const { items } = this.state;

        return (items.length > 0 ? <div>
            <MessageBar messageBarType={MessageBarType.info}>Logs des appels aux API liés à cette journalisation</MessageBar>

            <DetailsList
                columns={this.columns}
                constrainMode={ConstrainMode.unconstrained}
                items={items}
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
            />
        </div> : null);
    }

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            onAffichePanelFiltre: false,

            enCoursDeTraitement: false,
            messageEnCoursTraitement: null,

            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: ''
        };

        //#region chargement des columns
        this.columns = [];
        this.columns.push({
            key: 'idLog',
            minWidth: 50,
            maxWidth: 50,
            name: 'ID log',
            onRender: (item) => { return <span className="badge badge-secondary">{item.idLog}</span> }
        });
        this.columns.push({
            key: 'erreur',
            minWidth: 20,
            maxWidth: 20,
            name: '',
            onRender: (item) => { return (item.erreur ? <Icon iconName="AlertSolid" className="icon errorIcon" /> : null); }
        });
        this.columns.push({
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'loginCompte',
            minWidth: 100,
            maxWidth: 100,
            name: 'Compte util.',
            onRender: (item) => { return <span>{item.loginCompte}</span> }
        });
        this.columns.push({
            key: 'creerLe',
            minWidth: 125,
            maxWidth: 125,
            name: 'Date',
            onRender: (item) => { return <span>{Scriba.date().stringDateHeureFormatCourt(Scriba.date().getDateFromChaineISO(item.creerLe))}</span> }
        });
        this.columns.push({
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isMultiline: true,
            isResizable: true,
            key: 'nomWebService',
            minWidth: 150,
            maxWidth: 150,
            name: 'Nom du WS',
            onRender: (item) => { return <span>{item.nomWebService}</span> }
        });
        this.columns.push({
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            isMultiline: true,
            isResizable: true,
            key: 'corpsMessage',
            minWidth: 250,
            maxWidth: 500,
            name: 'Corps du message',
            onRender: (item) => { return <span>{item.corpsMessage}</span> }
        });
        this.columns.push({
            key: 'codeRetour',
            minWidth: 50,
            maxWidth: 50,
            name: 'Code',
            onRender: (item) => { return <span>{item.codeRetour}</span> }
        });
        this.columns.push({
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isMultiline: true,
            isResizable: true,
            key: 'messageRetour',
            minWidth: 250,
            maxWidth: 500,
            name: 'Message de retour',
            onRender: (item) => { return <span>{item.messageRetour}</span> }
        });
        //#endregion
    }

    _onAffichePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: true });
    };

    _onCachePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: false });
    };

    _onFiltreTableau = () => {
        this._chargementDonnees();
        this._onCachePanelFiltre();
    }

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={() => this._onFiltreTableau()} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={() => this._onCachePanelFiltre()}>Fermer</DefaultButton>
            </div>
        );
    };

    _chargementDonnees = () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                items: []
            });
            const objet = { "idJournalisation": this.props.idJournalisation };
            var url = 'api/Liste/ListeDesLogs';
            Immocom.liste()._chargementDonnees(this, url, objet);
        }
    }
    componentDidMount() { this._chargementDonnees(this.state.tri, this.state.recherche); };
    componentDidUpdate() { };
    componentWillUnmount() { };

    render = () => {
        let content = this._creationContent();

        return (<div>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <div className="ms-Grid-row">
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
            </div>

            <div className="ms-Grid-row">
                {content}
            </div>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={() => this._reinitFiltre()}
                            />
                        </div>
                    </div>

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            Aucun filtre
                        </div>
                    </div>
                </div>
            </Panel>
        </div>);
    }
}